import { Field } from '@app/api';

export const cleanLogicForAllFields = (fields: Field[]) => {
  const fieldsIds = fields.map((f) => f.id);
  return fields.map((field: Field, index: number) => {
    if (!field.jumpActions) {
      return field;
    }

    const jumps = field.jumpActions.filter((jump) => {
      if (!jump.toFieldId) {
        return true;
      }
      const targetIndex = fieldsIds.indexOf(jump.toFieldId);
      return targetIndex > index;
    });

    if (jumps.length !== field.jumpActions.length) {
      return {
        ...field,
        jumpActions: jumps,
      };
    }

    return field;
  });
};
